import styled from 'styled-components';
export const SortContainer = styled.div `
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=sort-on-title.styled.js.map